import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import slowRunningAnimation from '../assets/animations/slow_running_lottie.lottie';

const Loader = ({}) => {
  return (
    <div className="flex min-h-48 w-full items-center justify-center">
      <DotLottieReact
        src={slowRunningAnimation}
        loop
        autoplay
        className="w-32 h-32"
      />
    </div>
  );
};

export default Loader;
